import { FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { UseFormReturn } from "react-hook-form";
import { Camera, Mic, Users } from "lucide-react";
interface CommunicationStepProps {
  form: UseFormReturn<any>;
}
const CommunicationStep = ({
  form
}: CommunicationStepProps) => {
  return <div className="space-y-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold flex items-center gap-2">
          <Camera className="w-6 h-6 text-primary" />
          Comunicazione e Concorrenza
        </h2>
        <p className="text-muted-foreground">Definisci la tua strategia comunicativa</p>
      </div>

      <FormField control={form.control} name="appearInAds" render={({
      field
    }) => <FormItem className="space-y-3">
            <FormLabel>Sei disponibile a creare campagne pubblicitarie con il tuo volto?*</FormLabel>
            <FormControl>
              <RadioGroup onValueChange={field.onChange} defaultValue={field.value} className="flex flex-col space-y-2">
                <FormItem className="flex items-center space-x-3 space-y-0 border rounded-lg p-4 hover:bg-muted/50 transition-colors">
                  <FormControl>
                    <RadioGroupItem value="volto-si" />
                  </FormControl>
                  <FormLabel className="font-normal cursor-pointer flex-1">
                    Sì, sono disponibile a comparire con il mio volto
                  </FormLabel>
                </FormItem>
                <FormItem className="flex items-center space-x-3 space-y-0 border rounded-lg p-4 hover:bg-muted/50 transition-colors">
                  <FormControl>
                    <RadioGroupItem value="volto-no" />
                  </FormControl>
                  <FormLabel className="font-normal cursor-pointer flex-1">
                    No, preferisco non comparire con il volto
                  </FormLabel>
                </FormItem>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={form.control} name="voiceInAds" render={({
      field
    }) => <FormItem className="space-y-3">
            <FormLabel className="flex items-center gap-2">
              <Mic className="w-4 h-4" />
              Disponibilità Voce - Se non compari con il volto, la voce può aggiungere autenticità
            </FormLabel>
            <FormControl>
              <RadioGroup onValueChange={field.onChange} defaultValue={field.value} className="flex flex-col space-y-2">
                <FormItem className="flex items-center space-x-3 space-y-0 border rounded-lg p-4 hover:bg-muted/50 transition-colors">
                  <FormControl>
                    <RadioGroupItem value="voce-si" />
                  </FormControl>
                  <FormLabel className="font-normal cursor-pointer flex-1">
                    Sì, sono disponibile con la mia voce
                  </FormLabel>
                </FormItem>
                <FormItem className="flex items-center space-x-3 space-y-0 border rounded-lg p-4 hover:bg-muted/50 transition-colors">
                  <FormControl>
                    <RadioGroupItem value="voce-no" />
                  </FormControl>
                  <FormLabel className="font-normal cursor-pointer flex-1">
                    No, preferisco non usare la mia voce
                  </FormLabel>
                </FormItem>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={form.control} name="competitors" render={({
      field
    }) => <FormItem>
            <FormLabel className="flex items-center gap-2">
              <Users className="w-4 h-4" />
              Competitor nella Zona - Questo ci aiuta a posizionarti meglio sul mercato
            </FormLabel>
            <FormControl>
              <Textarea placeholder="Indica i nomi dei centri con offerta simile nella tua zona..." className="resize-none" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />
    </div>;
};
export default CommunicationStep;